<div
  class="flex align-items-center border-1 surface-border border-round-3xl w-full overflow-hidden px-3 py-2"
>
  <span
    class="flex-1 text-sm text-700 overflow-hidden text-overflow-ellipsis white-space-nowrap"
  >
    {{ link }}
  </span>

  <p-button
    [label]="copied ? 'Copied!' : 'Copy'"
    [severity]="copied ? 'primary' : 'secondary'"
    [rounded]="true"
    size="small"
    styleClass="border-round-3xl px-3 py-2 text-sm font-semibold"
    (onClick)="onCopyClick()"
  >
  </p-button>
</div>
